<template>
  <div id="app">
    <site-header v-if="showHeader"></site-header>
    <div id="page-container" :class="classes">
      <ui-container>
        <keep-alive :max="3">
          <router-view
            v-if="$route.meta.keepAlive && isRouterAlive"
          ></router-view>
        </keep-alive>
        <router-view
          v-if="!$route.meta.keepAlive && isRouterAlive"
          :key="$route.fullPath"
        ></router-view>
      </ui-container>
    </div>
    <!-- <div id="wrap" class="page-container"> -->
    <!-- <transition :name="transitionName" @before-enter="start" @after-leave="done" @after-enter="done"> -->
    <!-- </transition> -->
    <!-- <transition :name="transitionName" @before-enter="start" @after-leave="done" @after-enter="done"> -->
    <!-- </transition> -->
    <!-- </div> -->
    <!-- <ui-modal></ui-modal> -->
    <site-footer></site-footer>
  </div>
</template>
<script>
import siteHeader from "./components/SiteHeader.vue";
import siteFooter from "./components/Footer.vue";
import events from "./utils/event.js";
import vconsole from "./vconsole.js";
import { camelCaseToDash } from "./utils/utils.js";
import { mapGetters } from "vuex";
import removeClassByPrefix from "./utils/removeClass.js";
export default {
  components: {
    siteHeader,
    siteFooter
  },
  data() {
    return {
      transitionName: "",
      isRouterAlive: true,
      showHeader:true
    };
  },
  computed: {
    classes() {
      return "page-" + camelCaseToDash(this.$route.name);
    },
    ...mapGetters(["lang"])
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => (this.isRouterAlive = true));
    },
    start() {
      // console.log(this.$route)
      // let to = this.$route.to.name
      // let from = this.$route.from.name
      // if (to == 'EventArticleList' && from == 'EventView') {
      //   document.body.style.overflow = 'hidden'
      // }
    },
    done() {
      // let to = this.$route.to.name
      // let from = this.$route.from.name
      // if (to == 'EventArticleList' && from == 'EventView') {
      //   document.body.style.overflow = 'auto'
      // }
    }
  },
  watch: {
    lang() {
      removeClassByPrefix(document.body, "lang");
      document.body.classList.add(`lang-${this.lang.toLowerCase()}`);
    },
    $route(value){
      // if(value.meta.hasOwnProperty('showHeader') && !value.meta.showHeader){
      //   this.showHeader = value.meta.showHeader
      // }
    }
    // $route(to, from) {
    //   if (
    //     (to.name == "EventArticleList" && from.name == "EventView") ||
    //     (to.name == "BookArticleList" && from.name == "BookView")
    //   ) {
    //     this.transitionName = "slideInDown";
    //   } else if (
    //     (to.name == "EventView" && from.name == "EventArticleList") ||
    //     (to.name == "BookView" && from.name == "BookArticleList")
    //   ) {
    //     this.transitionName = "slideOutUp";
    //   } else {
    //     this.transitionName = "";
    //   }
    // }
  },
  mounted() {
    events.$on("network-error", () => {
      this.$UiToast({
        title: this.$t("networkError"),
        message: this.$t("serverCommunicateFaild"),
        icon: "warning-circle",
        duration: -1,
        type: "error",
        showClose: true,
        actions: [
          {
            icon: "sync",
            text: this.$t("refresh"),
            action: () => {
              location.reload();
            }
          }
        ]
      });
    });
    if (vconsole()) {
      vconsole().then(module => {
        var vConsole = new module.default();
      });
      window.onerror = (msg, url, lineNum, colNum, err) => {
        console.log(`错误发生的异常信息（字符串）:${msg}`);
        console.log(`错误发生的脚本URL（字符串）:${url}`);
        console.log(`错误发生的行号（数字）:${lineNum}`);
        console.log(`错误发生的列号（数字）:${colNum}`);
        console.log(`错误发生的Error对象（错误对象）:${err}`);
      };
      window.addEventListener("unhandledrejection", e => {
        console.log(
          `Promise.reject()中的内容，告诉你发生错误的原因:${e.reason}`
        );
        console.log(`Promise对象 :${e.promise}`);
      });
    }
  },
  beforeDestroy() {
    events.$on("network-error", () => {});
  }
};
</script>
<style lang="scss">
@import "./assets/scss/style.scss";
</style>
